export const getAllPriceGroups = (hierarchy) => {
const result = [];
    
const findLeafNodes = (node, parentName) => {
    if (node.depth == 2) {
        const labelParts = node.label?.split(":");
        const id = labelParts.length > 1? labelParts[0]?.trim()  : "";
        if(id){
            result.push({
                value: id,
                content: `${parentName} > ${node.label.replace(`${id}: `, "")} :${id}`
            });
        }
    }

    if (node.children) {
        node.children.forEach(child => {
            findLeafNodes(child, node.name);
        });
    }
}

hierarchy?.forEach(node => findLeafNodes(node, node.name));
return result;
}